import React, { useEffect } from "react";
import localData from "../../localData";
import { About, Experience, Skills, Projects, Services, Testimonials, Contact } from "../../components";
import observer from "../../utils/observer.js";

export default function Home() {
    useEffect(() => {
        setTimeout(() => {
            observer();
        }, 300);
    }, []); //temporary setTimeout

    return (
        <main>
            <About />
            <Experience />
            <Skills />
            <Projects />
            <Services />
            <Testimonials />
            <Contact />
        </main>
    );
}
